import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.GettingStartedPage.TeamInvitation', {
    title: 'Invite your teammates',
    description: 'Invite your teammates to set up the approval process and explore ApprovalMax together.',
    buttonText: 'Invite teammates',
});
